/*
 * @@Description: 对外事件
 * @@Author: MuYang
 * @Date: 2021-09-02 10:23:45
 * @LastEditTime: 2021-10-14 11:01:29
 */

import emitter from './emitter'
export default {
  mixins: [emitter],
  methods: {
    toggleRowSelection (rows, state) {
      this.broadcast('SyVcTable', 'toggleRowSelection', { rows, state })
    },
    toggleRowExpansion (rows, expanded) {
      this.broadcast('SyVcTable', 'toggleRowExpansion', { rows, expanded })
    },
    resetSelection () {
      this.broadcast('SyVcTable', 'resetSelection')
    }
  }
}
